import {Injectable} from '@angular/core';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {
    AnnualReportData, AnnualReportInput,
    FinancialIntervalType,
    FinancialSetting
} from '../_models/financial-management.model';
import {FinancialChartAccount} from '../_models/financial-account.model';

@Injectable({
    providedIn: 'root'
})
export class FinancialManagementService extends ApiService {

    constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'financial';


    public getFinancialPeriods(): Observable<string[]> {
        return this.client.get(this.url('utilities/periods'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).data as string[])));
    }

    public getDefaultCurrency(): Observable<string[]> {
        return this.client.get(this.url('utilities/currencies'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).data as string[])));
    }

    public getTaxType(): Observable<string[]> {
        return this.client.get(this.url('utilities/tax-types'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).data as string[])));
    }

    public getInterval(): Observable<FinancialIntervalType> {
        return this.client.get(this.url('utilities/payment-interval-types'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).data as FinancialIntervalType)));
    }

    public getCurrentSettings(): Observable<FinancialSetting> {
        return this.client.get(this.url('financial/organisation', true), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as FinancialSetting)));
    }

    public setCurrentSettings(settings: FinancialSetting): Observable<any> {
        return this.client.post(this.url('financial/organisation', true), settings, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public getAccountReport(accountId: string, projectId: string, fromYear: number, toYear: number): Observable<AnnualReportData[]> {
        let params = new HttpParams();
        params = params.set('from_year', String(fromYear));
        params = params.set('to_year', String(toYear));
        return this.client.get(this.url('account/' + accountId + '/project/' + projectId + '/annual'), {
            headers: this.defaultHeaders,
            responseType: 'json',
            params
        }).pipe(map(data => (data as any).data as AnnualReportData[]));
    }

    public getAccountFromClass(): Observable<FinancialChartAccount[]> {
        return this.client.get(this.url('financial/organisation/chart-of-accounts/class/1', true), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).accounts as FinancialChartAccount[])));
    }

    public getAccounts(): Observable<FinancialChartAccount[]> {
        return this.client.get(this.url('financial/organisation/chart-of-accounts', true), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).accounts as FinancialChartAccount[])));
    }

    public updateAccountData(annualInput: AnnualReportInput, year: string, accountId: string, projectId: string): Observable<any> {
        return this.client.post(this.url('financial/account/' + accountId + '/project/' + projectId + '/annual/' + year, true), annualInput, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => ((data as any).accounts as FinancialChartAccount[])));
    }
}
